import "./Comparision.scss";
import ScrollAnimationSection from "../../../components/scrollAnimSec/ScrollAnimSec";

const Comparision = () => {
  const dataList = [
    {
      id: 0,
      feature: "Call Handling",
      with: "Manages multiple calls 24/7, no wait",
      without: "Limited call capacity, missed calls",
    },
    {
      id: 1,
      feature: "Booking & Scheduling",
      with: "Auto-books meetings & sends reminders",
      without: "Manual scheduling, risk of errors",
    },
    {
      id: 2,
      feature: "Internal Queries",
      with: "AI routes and resolves quickly",
      without: "Manual ticketing, slower response",
    },
    {
      id: 3,
      feature: "Customer Feedback",
      with: "Real-time feedback with instant insights",
      without: "Feedback delayed or ignored",
    },
    {
      id: 4,
      feature: "Follow-Up on Issues",
      with: "Immediate outreach on low ratings",
      without: "Delayed or no follow-up",
    },
    {
      id: 5,
      feature: "Customer Retention",
      with: "Sends personalized offers to retain customers",
      without: "Limited retention efforts",
    },
    {
      id: 6,
      feature: "Team Productivity",
      with: "Saves time, reduces workload",
      without: "More manual work, lower efficiency",
    },
  ];

  return (
    <section className="comparision_sec p_t p_b">
      <div className="content_wrap">
        <ScrollAnimationSection>
          <div className="title">
            <h2 className="text-center">Why AI Agent?</h2>
          </div>
          <div className="compare_card_wrap">
            {dataList?.map((data) => {
              return (
                <div className="compare_card" key={data?.id}>
                  <h3>{data?.feature}</h3>
                  <div className="bi_info">
                    <div className="info_text">
                      <h5>With AI Agent</h5>
                      <p>{data?.with}</p>
                    </div>
                    <div className="info_text">
                      <h5>Without AI Agent</h5>
                      <p>{data?.without}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </ScrollAnimationSection>
      </div>
    </section>
  );
};

export default Comparision;
